import { ROLE_TYPES, auditRoleList, isAudit } from "./roleTypes";

export const decideLandingAfterLogin = (roleTypes) => {
  if (!roleTypes || !roleTypes.length) return "/";

  if (
    roleTypes.includes(ROLE_TYPES.DISBURSEMENT_APPROVER) ||
    roleTypes.includes(ROLE_TYPES.REPAYMENT_APPROVER)
  ) {
    return "/approve-loans";
  }

  if (isAudit([...roleTypes], [...auditRoleList])) {
    return "/manage-loans";
  }

  return "/main-dashboard";
};
